export default __webpack_public_path__ + "static/employeeSpouseKids-f3893d81b2b4dda8dc6be5087c5f567f.svg";